import { jsx as _jsx } from "react/jsx-runtime";
import { Heading as UIHeading } from '@phishtool/ui';
export const Heading = (props) => _jsx(UIHeading, Object.assign({}, props, { letterSpacing: true }));
